import React from "react";
import RecentSpeaker from './RecentSpeaker';

const RecentSpeakers = () => {
  return (
    <>
      <section className="about-fixed-image fixed-image-heading mt-5">
        <div>
          <h1 className="my-4 text-center">
            <span style={{ color: "red" }}>TEDx</span> IIT Jodhpur New Speakers
          </h1>
          <h2 className="my-3 text-center blur-fixed-image">
            Meet the new speakers who will be delivering the inspiring talks.
          </h2>
        </div>
      </section>
      <RecentSpeaker />
    </>
  );
};

export default RecentSpeakers;
